import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CommonMethod } from 'src/app-core/methods/common-methods';
import { CommonService } from 'src/app-core/services/common.service';
import { CustomerService } from 'src/app/customer/customer.service';
import { AppComponentBase } from 'src/app/shared/app-component-base';

@Component({
    selector: 'app-note-form',
    templateUrl: './note-form.component.html'

})
export class NoteFormComponent extends AppComponentBase implements OnInit {

    id: string;
    notes: any;
    accountId: any;
    quoteJobAccountId: any;
    isFormLoading = true;

    constructor(
        injector: Injector,
        private accountService: CustomerService,
        private commonService: CommonService,
        private commonMethod: CommonMethod,
        private router: Router,
        private toastr: ToastrService,
        private activatedRoute: ActivatedRoute) {
        super(injector);
    }

    ngOnInit(): void {
        this.commonMethod.getIsAccountId.subscribe((data: any) => {
            this.quoteJobAccountId = data;
        })
        switch (true) {
            case this.router.url.includes('customer-details'):
                this.id = this.activatedRoute.snapshot.params.customerId;
                break;
            case this.router.url.includes('lead-details'):
                this.id = this.activatedRoute.snapshot.params.leadId;
                break;
            case this.router.url.includes('quote-details'):
                this.id = this.quoteJobAccountId;
                break;
            case this.router.url.includes('job-details'):
                this.id = this.quoteJobAccountId;
                break;
            case this.router.url.includes('quote-form'):
                this.id = this.quoteJobAccountId;
                break;
            case this.router.url.includes('job-form'):
                this.id = this.quoteJobAccountId;
                break;
        }
        this.getNotes();
    }

    getNotes() {
        this.isFormLoading = true;
        this.accountService.editAccount(this.id)
            .pipe(finalize(() => (this.isFormLoading = false)))
            .subscribe(response => {
                this.accountId = response.data.id;
                this.notes = response.data.notes;
            })
    }

    onSaveAccountNote() {
        const noteData = {
            accountId: this.accountId,
            notes: this.notes
        };
        this.isFormLoading = true;
        this.commonService.createAccountNote(noteData)
            .pipe(finalize(() => (this.isFormLoading = false)))
            .subscribe(response => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    this.toastr.success(response.errors);
                } else {
                    this.toastr.error(response.errors);
                }
            });
    }
}

